import { useCallback, useState } from 'react';
import { useRecoilState } from 'recoil';
import { ReactComponent as SendIcon } from '../assets/svgs/send-icon.svg';
import { carouselMessageState, chatWidgetState } from '../recoil/atoms';

const AiChatCarouselSlide = () => {
  const [, setOpenChatWidget] = useRecoilState(chatWidgetState);
  const [, setCarouselMessage] = useRecoilState(carouselMessageState);
  const [userMessage, setUserMessage] = useState('');

  // const inputRef = useRef(null);

  // useEffect(() => {
  //   const input = inputRef.current;
  //   const slide = input?.closest('.slick-slide');
  //   if (
  //     currentSlide === 1 &&
  //     slide &&
  //     !slide.classList.contains('slick-cloned')
  //   ) {
  //     inputRef.current?.focus({ preventScroll: true });
  //   }
  // }, [currentSlide]);

  const handleSend = async e => {
    e.preventDefault();

    if (!userMessage.trim()) return;

    setCarouselMessage(userMessage);

    setUserMessage('');
    setOpenChatWidget(true);
  };

  const handleTextareaKeyDown = useCallback(
    e => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        e.target.form.requestSubmit();
        setUserMessage('');
        setOpenChatWidget(true);
      }
    },
    [setOpenChatWidget]
  );

  return (
    <div className='ai__slide__container'>
      <div className='ai__slide__text__content'>
        <h1 className='ai__slide__main__text'>
          Shipping Support.
          <br /> Anytime you need it.
        </h1>
        <p className='ai__slide__sub__text'>
          Our AI Shipping Assistant helps you get prices, book deliveries, track
          shipments, or chat with a human — all in one place, 24/7.
        </p>
        <div className='ai__slide__input__container'>
          <form
            commentMore
            actions
            className='chat-widget__input-area'
            onSubmit={e => handleSend(e)}
            style={{ width: '50% !mportant' }}
          >
            <textarea
              rows={1}
              type='text'
              value={userMessage}
              onChange={e => {
                setUserMessage(e.target.value);
                setCarouselMessage(e.target.value);
              }}
              onKeyDown={handleTextareaKeyDown}
              placeholder='Try the assistant'
              className='chat-widget__input'
              tabIndex='-1'
              aria-hidden='true'
              // ref={inputRef}
            />
            <button
              type='submit'
              className='chat-widget__send-icon'
              tabIndex='-1'
              aria-hidden='true'
            >
              <SendIcon />
            </button>
          </form>
        </div>
      </div>
      <div className='ai__slide__img__container'>
        <div className='img__slide__text__box'>
          Hi, i’m Topship’s AI Assistant,
          <br /> how can I make shipping
          <br /> easier for you today?
        </div>
        <img
          src='/assets/a-robot.webp'
          alt="ai chatbot robot's pic"
          className='ai__robot__img'
        />
      </div>
    </div>
  );
};

export default AiChatCarouselSlide;
